import React, { memo } from 'react'
import { TableHead, TableRow, TableCell } from 'transfix-ui/components/Table'
import { Typography } from 'transfix-ui/core'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import { getColumns } from '../../columns'

export const SavedLanesTableHeader = memo(() => {
  const refactoredSavedLanesCreateAndUpdateEnabled = useFeatureFlag(
    'refactoredSavedLanesCreateAndUpdate'
  )
  const tableColumns = getColumns(refactoredSavedLanesCreateAndUpdateEnabled)

  return (
    <TableHead>
      <TableRow tableCellType='th'>
        {Object.entries(tableColumns).map(([key, column]) => (
          <TableCell key={key}>
            <Typography variant='caption' color='textSecondary'>
              {column}
            </Typography>
          </TableCell>
        ))}
        <TableCell>{}</TableCell>
      </TableRow>
    </TableHead>
  )
})
